export default {
  slots: {
    root: 'w-full',
  },
  variants: {
    type: {
      file: 'file:!bg-stone-100 file:!text-gray-950 file:!border-stone-200 file:!rounded file:!border-2 file:!border-dashed file:!px-2 file:cursor-pointer hover:file:!bg-stone-900 hover:file:!text-white hover:file:!border-stone-900 file:transition-all file:duration-300',
    },
  },
}
